<template>
    <v-container>
        <v-row>
            <v-col>
                <v-text-field v-model="value" color="#c42111" :hint="hint" persistent-hint @change="onChange" :rules="[validation.number(value, isNum), validation.min(value, isNum, min), validation.max(value, isNum, max)]" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'TextBox',
    props: ['param'],
    data: () => ({
        hint: '',
        value: '',
        isNum: false,
        min: '',
        max: '',
        validation: {
            number: (value, isNum) => !(isNum && (isNaN(value) || isNaN(parseFloat(value)))) || `Value must be a number`,
            min: (value, isNum, min) => !(isNum && value < min) || `Minimum value is ${min}`,
            max: (value, isNum, max) => !(isNum && value > max) || `Maximum value is ${max}`
        }
    }),

    computed: {

    },

    methods: {
        onChange: function() {
            this.param.selectedValue = this.value;
            this.param.humanText = `${this.param.rpt_param_user_name}: ${this.value}`;

            this.$emit('edit');
        },

        buildList: function() {
            let params = this.param.rpt_param_values.slice();
            this.hint = params[0];
            this.value = params[1];
            this.isNum = (params[2].toLowerCase() == 'true') ? true : false;
            this.min = parseInt(params[3]);
            this.max = parseInt(params[4]);
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            this.value = this.$props.param.encodedValue;
        }
    },

    mounted() {
        this.buildList();
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>

</style>

